const extractGeo = (geopoint2d: string): number[] => {
    let geo: string[];   
    geo=geopoint2d.split(", ");
    return [+geo[0],+geo[1]]
     }

export default extractGeo;